<template>
  <TableSkeleton v-show="loading || localLoading" width="200px" />
  <a-table
    :columns="columns"
    :data-source="queuesInfo.items"
    :loading="loading"
    row-key="id"
    size="middle"
    :pagination="queuesInfo.pagination"
    :scroll="scrollStyle"
    @change="handleTableChange"
    v-show="!loading && !localLoading"
  >
    <template #channels_customer="{ record }">
      <div class="table__row--flex">
        <div v-for="item in sortedChannel(record.channels_customer)" :key="item.id" class="icon--channel">
          <a-popover>
            <template #title>
              <span> Canal de {{ formatName(item.channel.name) }} </span>
            </template>
            <template #content>
              <ul class="list">
                <li>
                  {{ getAssociated(item) }}
                </li>
              </ul>
            </template>
            <icon-channel
              :type="item.channel.id"
              :src="item.channel.icon"
              :width="item.channel.id == 5 ? 22 : 20"
            />
          </a-popover>
        </div>
      </div>
    </template>

    <template #portfolios="{ record }">
      {{ record.portfolios.length > 0 ? record.portfolios[0].name : "Sin campaña" }}
    </template>

    <template #level_service="{ record }"> {{ record.level_service }} seg </template>

    <template #waiting_threshold="{ record }"> {{ record.waiting_threshold }} seg </template>

    <template #agents="{ record }">
      {{ record.agents.length + record.supervisors.length || 0 }}
      <a-tooltip>
        <template #title>
          Recuerda agregar usuarios a esta cola para que atiendan los tickets asignados.</template
        >
        <ExclamationCircleOutlined
          v-if="!record.agents.length && !record.supervisors.length"
          class="icon--exclamation"
        />
      </a-tooltip>
    </template>

    <template #status="{ record }">
      <a-tag v-if="record.status == 1" color="green"> Activo </a-tag>
      <a-tag v-else> Inactivo </a-tag>
    </template>

    <template #actions="{ record }">
      <a-space id="queue-actions">
        <queue-switch-button :queue="record" @update="handleUpdate" validate-bot/>
        <queue-editor-button :queue="record" @update="handleUpdate" />
        <queue-delete-button :queue="record" @update="handleUpdate" validate-bot />
      </a-space>
    </template>
  </a-table>
</template>

<script>
// TODO-JOHN: Refactor, remover modals de la tabla
import { defineComponent, ref } from "vue";
import { ExclamationCircleOutlined } from "@ant-design/icons-vue";

import { queuesTableColumns } from "@/app/queues/utils/constants";
import { useScrollResize } from "@/app/shared/composables/useScrollResize";
import { sortIconChannels } from "@/app/common/utils/sortIconChannels";

import QueueEditorButton from "@/app/queues/components/buttons/QueueEditorButton.vue";
import QueueSwitchButton from "@/app/queues/components/buttons/QueueSwitchButton.vue";
import QueueDeleteButton from "../buttons/QueueDeleteButton.vue";
import IconChannel from "@/app/shared/components/icons/IconChannel.vue";
// import fetchValidateQueuesBots from "@/app/entities/services/requests/portfolios/fetchValidateQueuesBots.js";
import TableSkeleton from "@/app/shared/components/skeletons/TableSkeleton.vue";

export default defineComponent({
  components: {
    QueueEditorButton,
    QueueSwitchButton,
    IconChannel,
    QueueDeleteButton,
    ExclamationCircleOutlined,
    TableSkeleton,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const { scrollStyle } = useScrollResize({ headerMargin: 280 });
    const validateBot = ref(false);
    return { scrollStyle, validateBot };
  },
  data() {
    return {
      columns: queuesTableColumns,
      localLoading: false,
    };
  },
  computed: {
    queuesInfo() {
      return this.$store.getters["getQueueInfo"];
    },
  },
  created() {
    this.handleFetchQueues(this.pagination);
  },
  methods: {
    // async handleValidateQueuesBots(id) {
    //   try {
    //     const response = await this.fetchValidateQueuesBots(id);
    //     validateBot.value = true;
    //   } catch (error) {
    //     console.error("Error fetching validate queues bots:", error);
    //   }
    // },
    handleTableChange(pagination) {
      this.handleFetchQueues(pagination);
    },
    async handleFetchQueues(pagination) {
      this.localLoading = true;
      await this.$store.dispatch("fetchAllQueues", { pagination });
      this.localLoading = false;
    },
    getAssociated(item) {
      if (item.data_parameters?.phone_number) {
        return `${item.data_parameters.phone_number} (${item.alias})`;
      }

      if (item.data_parameters?.name) {
        return item.data_parameters.name;
      }

      if (item.data_parameters?.domain) {
        return item.data_parameters.domain;
      }
      return "";
    },
    formatName(name) {
      switch (name) {
        case "Telefonica":
          return "Voz";
        case "Messenger":
          return "Facebook Messenger";
        case "Chat Inbound":
          return "Web Chat";
        default:
          return name;
      }
    },
    handleUpdate() {
      this.$emit("update");
    },
    sortedChannel(list) {
      return sortIconChannels(list);
    },
  },
});
</script>

<style lang="sass" scoped>
:deep(.ant-table-thead > tr > th)
  // padding: 10px !important

.table
  &__row
    &--flex
      display: flex

.icon
  &--channel
    margin-right: 8px
  &--exclamation
    color: $orange-6
    margin-left: 3px

// :deep(.ant-table-tbody > tr > td)
//   padding-left: 8px

//   &:first-child
//     padding-left: 16px

//   &:last-child
//     padding-left: 0
</style>
